import {
  determineValueStatus,
  isValueCompatible,
  isValueConstrained,
} from "../../../utils/ProductBuilderHelper";
import { replaceCloudinaryUrlTokens } from "../../../utils/cloudinaryUrlUtil";
import { MpvOption, MpvValue } from "../../../types/ContentfulTypes";
import { AttributeConstraint } from "../../../types/ConstraintsTypes";
import { ProductOptionListModel } from "@vp/product-options-ui";
import { determineCallout } from "./determineCallout";

export enum CalloutKey {
  ERROR = "error",
  PROMOTION = "promotion",
}

export type ProductOptionChoiceButtonDictionary = {
  outOfStockText: string;
  selectorIncompatibleText: string;
  newCalloutText: string;
  recommendedText: string;
};

export const mapMpvValueToProductOptionChoice = ({
  optionValue,
  option,
  selections,
  compatibleValues,
  attributeConstraints,
  showIncompatibleValues,
  dictionary,
}: {
  optionValue: MpvValue;
  option: MpvOption;
  selections: Record<string, string>;
  compatibleValues: Record<string, string[]>;
  attributeConstraints: AttributeConstraint[];
  showIncompatibleValues: boolean;
  dictionary: ProductOptionChoiceButtonDictionary;
}): ProductOptionListModel => {
  const isCompatible = isValueCompatible(option, optionValue, compatibleValues);

  const { isConstrained, isAlwaysConstrained } = isValueConstrained({
    option: option.key,
    value: optionValue.key,
    attributeConstraints: attributeConstraints,
    selections: selections,
  });

  const { selectorDisabled, selectorStatusMsg } = determineValueStatus({
    isPrimaryAttribute: showIncompatibleValues,
    isCompatible,
    isConstrained,
    isAlwaysConstrained,
    outOfStockMessage: dictionary.outOfStockText,
    incompatibleMessage: dictionary.selectorIncompatibleText,
  });

  const callout = determineCallout(selectorStatusMsg, optionValue, dictionary);

  const imageUrl = optionValue.images
    ? replaceCloudinaryUrlTokens(optionValue.images[0], { IMAGE_WIDTH: "200" })
    : undefined;

  return {
    key: optionValue.key,
    name: optionValue.name,
    description: optionValue.marketingText,
    isCompatible,
    isOutOfStock: selectorDisabled,
    callouts: callout ? [callout] : undefined,
    image: imageUrl,
  };
};
